import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUsers, FiChevronRight, FiTrendingUp, FiLayers } = FiIcons;

const AffiliationGroups = () => {
  const navigate = useNavigate();

  const groups = [
    {
      id: 'clarusone',
      name: 'ClarusOne',
      members: ['McKesson', 'Walmart', 'Optum'],
      totalSales: '$124.5M',
      growth: '+12.4%',
      activeProducts: 45
    },
    {
      id: 'redoak',
      name: 'RedOak Sourcing',
      members: ['CVS Health', 'Cardinal Health'],
      totalSales: '$98.2M',
      growth: '+8.7%',
      activeProducts: 38
    },
    {
      id: 'wbad',
      name: 'WBAD (Walgreens Boots Alliance Development)',
      members: ['Walgreens', 'AmerisourceBergen'],
      totalSales: '$85.6M',
      growth: '+15.2%',
      activeProducts: 42
    },
    {
      id: 'econdisc',
      name: 'Econdisc Health Options',
      members: ['Express Scripts', 'Kroger', 'Rite Aid'],
      totalSales: '$62.1M',
      growth: '+5.4%',
      activeProducts: 31
    }
  ];

  return (
    <div className="space-y-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6"
      >
        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
            <SafeIcon icon={FiLayers} className="text-blue-600 text-2xl" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Affiliation Groups</h1>
            <p className="text-gray-600">Strategic purchasing groups and their member entities</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {groups.map((group, index) => (
            <motion.div
              key={group.id}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.1 }}
              onClick={() => navigate(`/affiliation-group/${group.id}`)}
              className="group cursor-pointer bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-lg hover:border-blue-300 transition-all"
            >
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                    {group.name}
                  </h3>
                  <div className="flex flex-wrap gap-2 mt-2">
                    {group.members.map(member => (
                      <span key={member} className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-md">
                        {member}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="p-2 bg-blue-50 rounded-lg text-blue-600 opacity-0 group-hover:opacity-100 transition-opacity">
                  <SafeIcon icon={FiChevronRight} />
                </div>
              </div>

              <div className="grid grid-cols-3 gap-4 pt-4 border-t border-gray-100">
                <div>
                  <p className="text-xs text-gray-500 uppercase tracking-wider mb-1">Total Sales</p>
                  <p className="font-bold text-gray-900">{group.totalSales}</p>
                </div>
                <div>
                  <p className="text-xs text-gray-500 uppercase tracking-wider mb-1">Growth</p>
                  <p className="font-bold text-green-600">{group.growth}</p>
                </div>
                <div>
                  <p className="text-xs text-gray-500 uppercase tracking-wider mb-1">Products</p>
                  <p className="font-bold text-gray-900">{group.activeProducts}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default AffiliationGroups;